import { FolderPlus } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const AddFolderIcon = DeckardIconWrapper({ Icon: FolderPlus });
